import { useState } from "react";
import Notify from "devextreme/ui/notify";
//DBTables
import { DBModule } from "../../../types/DBTables";
import { UseFormReturn } from "react-hook-form";

import NumberEditor from "../../Global/Editors/NumberEditor";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import TextEditor from "../../Global/Editors/TextEditor";
import { useGlobalData } from "../../GlobalDataProvider";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { DTOModule } from "../../../types/building";
import { IModuleRound } from "../../../modules/roundHandler";
import { nameof } from "../../Global/Utils";
import { IModuleKylmaskin, IModuleVärmeEl } from "../../../types/ModuleDatas";
import { MapTooltip } from "../../../types/globalData";
import BFLNote from "../BFL/BFLNote";
import { watch } from "fs";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundKylmaskin = ({ module, data, formHook }: IProps) => {
  const watch = formHook.watch;
  const kylmaskinUppdateradStatistik = watch(nameof<IModuleKylmaskin>("harUppdateradStatistik"));

  return (
    <>
      {/* RoundKylmaskin */}
      <div className="row ml-0">
        <div className="col-lg-12">
          <SelectEditor
            label="Ange om energistatistik (kWh) för EL och kyla är uppdaterad."
            fieldName={nameof<IModuleKylmaskin>("harUppdateradStatistik")}
            tooltipId={nameof<MapTooltip>("KylaKylmaskin_harUppdateradStatistik")}
            formHook={formHook}
            items={["", "Ja", "Nej"]}
            options={{
              validate: {
                required: (value: any) => (value ? undefined : "Du måste ange Ja eller Nej"),
              },
            }}
          ></SelectEditor>
        </div>
      </div>
      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Kylmaskinens årliga avgivning av komfortkyla (kWh).12 månaders ackumulerat värde."
            fieldName={nameof<IModuleKylmaskin>("årligAvgivning")}
            tooltipId={nameof<MapTooltip>("KylaKylmaskin_årligAvgivning")}
            isDisabled={kylmaskinUppdateradStatistik === "Ja" ? false : true}
            formHook={formHook}
            options={{ required: "Måste fyllas i" }}
          ></NumberEditor>
        </div>
      </div>
      <div className="row ml-0">
        <div className="col-lg-12">
          <NumberEditor
            label="Kylmaskinens årlig elanvändning (kWh). 12 månaders ackumulerat värde."
            fieldName={nameof<IModuleKylmaskin>("årligElanvändning")}
            tooltipId={nameof<MapTooltip>("KylaKylmaskin_årligElanvändning")}
            isDisabled={kylmaskinUppdateradStatistik === "Ja" ? false : true}
            formHook={formHook}
            options={{ required: "Måste fyllas i" }}
          ></NumberEditor>
        </div>
      </div>
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundKylmaskin;
